import React from 'react';
import { Link } from 'react-router-dom';

const DocumentTypeSelector = ({ 
  documentTypes, 
  selectedDocumentType, 
  loading, 
  user, 
  onChange 
}) => {
  return (
    <div className="mb-2">
      <label className="form-label fw-semibold">
        <i className="bi bi-file-earmark-text me-2 text-primary"></i>
        Tipo de Documento
      </label>
      {loading ? (
        <div className="d-flex align-items-center p-3 bg-light rounded-3">
          <div className="spinner-border spinner-border-sm me-2 text-primary" role="status"></div>
          <span className="text-muted">Cargando tipos de documentos...</span>
        </div>
      ) : (
        <select 
          className="form-select form-select-lg" 
          value={selectedDocumentType}
          onChange={(e) => onChange(e.target.value)}
          disabled={documentTypes.length === 0}
        >
          {documentTypes.length === 0 ? (
            <option value="">No hay tipos de documentos disponibles</option>
          ) : (
            <>
              <option value="">Seleccionar tipo de documento</option>
              {Array.isArray(documentTypes) && documentTypes.map(docType => (
                <option key={docType.id} value={docType.id}>
                  {docType.nombre}
                  {user?.role === 'admin' && docType.is_public && ' (Público)'}
                </option>
              ))}
            </>
          )}
        </select>
      )}
      
      {documentTypes.length === 0 && !loading && (
        <div className="mt-3 p-3 bg-warning bg-opacity-10 border border-warning rounded-3">
          <div className="d-flex align-items-start">
            <i className="bi bi-exclamation-triangle text-warning me-2 mt-1"></i>
            <div>
              <small className="text-warning-emphasis">
                <strong>Sin documentos configurados</strong>
              </small>
              <br />
              <small className="text-muted">
                {user?.role === 'admin' ? (
                  <>
                    No has creado plantillas públicas aún. 
                    <Link to="/configuracion" className="text-decoration-none fw-medium ms-1">
                      Crear plantilla
                    </Link>
                  </>
                ) : (
                  <>
                    No tienes tipos de documentos configurados. 
                    <Link to="/configuracion" className="text-decoration-none fw-medium ms-1">
                      Configurar documentos
                    </Link>
                  </>
                )}
              </small>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentTypeSelector;
